import type { Activity } from '@/model/sourceState/sourcestate.generated';
import type { ActivityView } from '@/viewmodel/features/sourceState/types';

export function toActivityView(activity: Activity | null | undefined): ActivityView | undefined {
  if (!activity) return undefined;

  return {
    name: activity.name,
    stageCode: activity.stage_code || undefined,
    stageIndex: activity.stage_index ?? undefined,
    stageTotal: activity.stage_total ?? undefined,
    detail: activity.detail || undefined,
  };
}
